import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpEventType, HttpRequest, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class UploadService {

  constructor(private readonly http: HttpClient) {}

  /**
   * PUT file to a pre-signed URL, reporting progress 0-1 and completion boolean.
   */
  putWithProgress(url: string, file: File): Observable<{ progress: number; done: boolean }> {
    const req = new HttpRequest('PUT', url, file, {
      reportProgress: true,
      // Do not force Content-Type for pre-signed S3 uploads. If Content-Type is included
      // in the signature on the backend (or if the browser changes it), S3 can return
      // SignatureDoesNotMatch. Leaving it unset makes uploads more robust.
    });
    return this.http.request(req).pipe(
      filter((evt: HttpEvent<any>) =>
        evt.type === HttpEventType.UploadProgress || evt.type === HttpEventType.Response),
      map(evt => {
        if (evt.type === HttpEventType.UploadProgress) {
          const progress = evt.total ? evt.loaded / evt.total : 0;
          return { progress, done: false };
        }
        return { progress: 1, done: true };
      })
    );
  }
}


